import { useState } from 'react'

import RadioButton from 'ageas-react-component-radiobutton'

import { Question } from '../../Types/AnimalStore'
import { OPTIONS_YES_NO } from '../../constants/optionsYesNo'
import { t } from '../../i18n'

type RadioProps = {
  item: Question
  changeValue: (value: string) => void
  disable?: boolean
  readOnly?: boolean
  isMandatory?: boolean
}

export const Radio = ({
  item,
  changeValue,
  disable,
  readOnly,
  isMandatory,
}: RadioProps) => {
  const [value, setValue] = useState(item.answer)

  return (
    <RadioButton
      id={item.id}
      name={item.id}
      label={`${item.question}${isMandatory ? ' *' : ''}`}
      colorTheme="blue"
      version="2"
      required={true}
      value={value}
      readOnly={readOnly}
      onValueChanged={(id: any, value: any) => {
        if (!disable) {
          changeValue(value)
          setValue(value)
        }
      }}
      options={[
        {
          value: OPTIONS_YES_NO.yes,
          caption: t('general.pt.yes'),
        },
        {
          value: OPTIONS_YES_NO.no,
          caption: t('general.pt.no'),
        },
      ]}
    />
  )
}
